import { atom } from "jotai";

interface WorkspaceUserPermissionsState {
  permissions: string[];
}

const initialState: WorkspaceUserPermissionsState = {
  permissions: [],
};

export const workspaceUserPermissionsAtom = atom<WorkspaceUserPermissionsState>(initialState);

export const currentWorkspaceUserPermissionsAtom = atom(get => get(workspaceUserPermissionsAtom).permissions);
